const userRole = {
  1: 'owner',
  2: 'admin',
  3: 'content-writer',
  4: 'tester',
  5: 'date-selector',
  6: 'marketing',
  7: 'tester-internal',
}

export default userRole
